"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetSsoToken {
    static getAttributeTypeMap() {
        return GetSsoToken.attributeTypeMap;
    }
}
GetSsoToken.discriminator = undefined;
GetSsoToken.attributeTypeMap = [
    {
        "name": "token",
        "baseName": "token",
        "type": "string"
    }
];
exports.GetSsoToken = GetSsoToken;
//# sourceMappingURL=getSsoToken.js.map